export const ZIP_CODE_REGEX = /^(?:\d{3}-?\d{4})?$/;
